import { Injectable } from '@angular/core';
import { ProjectSummaryRow } from './project-summary.types';

@Injectable()
export class ProjectSummaryDataService {
    toRows(input: unknown[]): ProjectSummaryRow[] {
        return (input || []).map((item: any) => ({
            projectID: Number(item.projectID ?? item.id ?? 0),
            projectName: item.projectName || item.name || '',
            isAccessible: item.isAccessible !== false,
            excluded: !!item.excluded,
            created: item.created,
            projectUpdated: item.projectUpdated || item.updatedDate || item.lastUpdated,
            energySector: item.energySector || item.sector,
            country: item.country,
            companyName: item.companyName,
            dollarValue: item.dollarValue,
            startupYear: item.startupYear,
            projectStage: item.projectStage,
            projectStatus: item.projectStatus,
            trackingStatus: item.trackingStatus || item.status
        }));
    }
}
